import { Address } from "../../interfaces/Space"

type Props = {
    address: Address
}

const getPartTwo = (address: Address) => {
    return address.partTwo.trim() ? `${address.partTwo}` : '';
}

const getZipCode = (address: Address) => {
    return address.zipCode.trim() ? `${address.zipCode}` : ''
}

const getCity = (address: Address) => {
    return address.city.trim() ? `${address.city.trim()}` : ''
}

export default function ObjectAddress({ address }: Props) {

    return <div>
        <div>{`${address.partOne}, ${getPartTwo(address)}`}</div>
        <div>{`${getZipCode(address)} ${getCity(address)}`}</div>
    </div>
}